module.exports = __webpack_public_path__ + "img/home.12df2db3.svg";